'use strict';

let packagenamePass = (rule, value, callback) => {
    let reg = /^[\w][\w\d]*([.][\w][\w\d]*)+$/;
    if(value){
        reg.test(value) ?  callback() : callback(new Error("格式错误,例如com.mapbar.com"));
    };
};
let deviceIdListPass = (rule, value, callback) => {
    if(value.some(item => { return item == ''})){
        callback(new Error("不可为空"));
    }else{
        callback();
    }
}

function getRules() {
    return {
        title:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        company:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        changeType:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        category:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        startTime:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        endTime:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        priority:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        changeOrigin:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        influence:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        emergency:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        risk:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],

        apptype:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        packagename:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
            { max:128, message: '最大长度为128', trigger: 'change,blur'},
            { validator:packagenamePass ,trigger: 'change,blur'}
        ],
        remark:[
            { max:100, message: '最大长度为100', trigger: 'change,blur'},
        ],

        message:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
            { max:100, message: '最大长度为100', trigger: 'change,blur'}
        ],
        deviceIdList:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
            { validator:deviceIdListPass ,trigger: 'change,blur'}
        ],
        env:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        projectName:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        serviceClass:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],


    };
}
export {
    getRules
}
